import React, { useState } from "react";
import styled from "styled-components";

// import { device } from "src/styles/device";
// import { getLocale } from "react-i18nify";
import * as MatStyled from "@mui/material/styles";
import { Primary } from "src/styles/color";
import device from "src/styles/device";

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  position: relative;
  padding: 80px 40px;
  margin: auto;
  & > div > p {
    word-wrap: break-word;
  }

  @media ${device.tabletL} {
    padding: 16px 24px;
  }

  @media ${device.mobileL} {
    padding: 16px;
  }
`;

const VideoTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const VideoTabsList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0;
  width: 100%;
  flex-shrink: 0;
`;

const VideoDetailsWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  border: 2px solid #e13b30;
  border-radius: 0 8px 8px 8px;
  flex-direction: column;
  gap: 0;
`;

const VideoTabButton = styled.button`
  background: ${(props) => (props.active ? Primary : "#f5f5f5")};
  color: ${(props) => (props.active ? "#fff" : "#333")};
  border: ${(props) =>
    props.active ? `2px solid ${Primary}` : "2px solid #ddd"};
  padding: 10px 16px;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 700;
  transition: all 0.3s ease;
  text-align: left;
  width: auto;
  white-space: nowrap;
  line-height: 1.3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  /* transform: ${(props) =>
    props.active ? "translateY(-2px)" : "translateY(0)"}; */
  /* margin-right: ${(props) => (props.active ? "2px" : "0")}; */

  &:hover {
    background: ${(props) => (props.active ? Primary : "#efefef")};
    border-color: ${Primary};
  }
`;

const VideoSection = styled.div`
  margin-top: 0;
  padding: 24px;
  background: #fafafa;
  border-radius: 0 0 8px 8px;
  border-top: none;
  animation: slideDown 0.3s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const VideoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e0e0e0;
`;

const VideoTitle = styled.p`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
`;

const VideoPlayerContainer = styled.div`
  background: #f7f7f7;
  display: flex;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e8e8e8;

  video {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    max-width: 100%;
    border-radius: 8px;
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: 0,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const TutorialVideo = ({ open }) => {
  const videos = [
    {
      id: 1,
      title: "ขั้นตอนการลงสินค้า",
      videoSrc:
        "https://xsurface-images.s3.ap-southeast-1.amazonaws.com/Final+++%E0%B8%AA%E0%B8%AD%E0%B8%99%E0%B8%A5%E0%B8%B9%E0%B8%81%E0%B8%84%E0%B9%89%E0%B8%B2%E0%B8%A5%E0%B8%87%E0%B8%AA%E0%B8%B4%E0%B8%99%E0%B8%84%E0%B9%89%E0%B8%B2%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%9A%E0%B9%89%E0%B8%B2%E0%B8%99%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%A7%E0%B9%87%E0%B8%9B.mp4",
      pdfUrl:
        "https://xsurface-images.s3.ap-southeast-1.amazonaws.com/%E0%B8%84%E0%B8%B3%E0%B9%81%E0%B8%99%E0%B8%B0%E0%B8%99%E0%B8%B3%E0%B9%83%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B1%E0%B9%89%E0%B8%87%E0%B8%8A%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%AA%E0%B8%B4%E0%B8%99%E0%B8%84%E0%B9%89%E0%B8%B2%E0%B8%9A%E0%B8%99++XSURFACE.COM.pdf",
    },
    {
      id: 2,
      title: "ขั้นตอนการใช้ AI สร้างภาพ",
      videoSrc:
        "https://xsurface-images.s3.ap-southeast-1.amazonaws.com/%E0%B8%AA%E0%B8%AD%E0%B8%99%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%9F%E0%B8%B1%E0%B8%87%E0%B8%81%E0%B9%8C%E0%B8%8A%E0%B8%B1%E0%B8%99AI.mp4",
      pdfUrl: null,
    },
  ];

  const [selectedVideoId, setSelectedVideoId] = useState(1);
  const selectedVideo = videos.find((v) => v.id === selectedVideoId);

  return (
    <Main
      sx={{ width: "100%", marginTop: "75px", background: "#fff" }}
      open={open}
    >
      <Container>
        <h2 style={{ marginBottom: "24px" }}>บทเรียนวิดีโอ</h2>

        <VideoTabsContainer>
          <VideoTabsList>
            {videos.map((video) => (
              <VideoTabButton
                key={video.id}
                active={selectedVideoId === video.id}
                onClick={() => setSelectedVideoId(video.id)}
              >
                <span>{video.title}</span>
              </VideoTabButton>
            ))}
          </VideoTabsList>

          <VideoDetailsWrapper>
            {selectedVideo && (
              <VideoSection>
                <VideoHeader>
                  <VideoTitle>{selectedVideo.title}</VideoTitle>

                  <div style={{ display: "flex", gap: "8px" }}>
                    <a
                      href={selectedVideo.videoSrc}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        background: Primary,
                        color: "#fff",
                        padding: "8px 12px",
                        borderRadius: "8px",
                        textDecoration: "none",
                        fontSize: "0.95rem",
                      }}
                    >
                      ดาวน์โหลดคลิป
                    </a>

                    {selectedVideo.pdfUrl && (
                      <a
                        href={selectedVideo.pdfUrl}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          background: "#fff",
                          color: "#333",
                          padding: "8px 12px",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                          textDecoration: "none",
                          fontSize: "0.95rem",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        คำแนะนำการตั้งชื่อสินค้าบนเว็บไซต์
                      </a>
                    )}
                  </div>
                </VideoHeader>

                <VideoPlayerContainer>
                  <video
                    autoPlay
                    controls
                    muted
                    loop
                    src={selectedVideo.videoSrc}
                  />
                </VideoPlayerContainer>
              </VideoSection>
            )}
          </VideoDetailsWrapper>
        </VideoTabsContainer>
      </Container>
    </Main>
  );
};

export default TutorialVideo;
